import React, { useEffect, useState } from 'react'
import PillBtn from '../../components/PillBtn'
import { useTranslate } from '../../components/TranslationText'
import ShowEntryHorseCard from '../../components/showEntry/ShowEntryHorseCard';
import SearchBox from '../../components/SearchBox';
import { useLocation, useNavigate } from 'react-router';
import axiosInstance from '../../axios/axios';
import { aedLogoStyle, eFormButtonsContainer, getDirhamImage, iconContainer, noDataCard, showIconsContainer, termsTitle } from '../../common/cssclasses';
import NewActionButton from '../../components/ActionButtons/NewActionButton';
import { convertToCamelCase } from '../../helper/convertToCamelCase';
import DraftBtn from '../../components/servicesButtons/DraftBtn';
import SubmitServiceBtn from '../../components/servicesButtons/SubmitServiceBtn';
import { convertDubaiToUTC } from '../../helper/convertDubaiToUTC';
import { createShowEntry, getShowEntryHorses } from './apis/CreateShowEntry';
import UserDropDown from '../../components/showEntry/UserDropDown';
import Loader from '../../components/Loader';
import { toast, ToastContainer } from 'react-toastify';


const BaseURL = process.env.REACT_APP_BASE_URL;

export default function ShowParticipatePage() {
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const ownerId = localStorage.getItem('currentSubAccountId');
    const { translate } = useTranslate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const showId = searchParams.has("showId")
        ? searchParams.get("showId")
        : "";
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('draft');
    const [horseSearchValue, setHorseSearchValue] = useState('');
    const [maxAllowedHorses, setMaxAllowedHorses] = useState(10);
    const [showDetails, setShowDetails] = useState({});
    const [horsesList, setHorsesList] = useState([]);
    const [loaded, setLoaded] = useState(true);
    const [detailsLoaded, setDetailsLoaded] = useState(true);
    const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
    const [skipHorses, setSkip] = useState(0);
    const take = 150;
    const [isLoadingMore, setIsloadingMore] = useState(false);
    const [totalcount, setTotalCount] = useState(0);
    const [totalIncomingHorses, setTotalIncomingHorses] = useState(0);
    const [timeoutId, setTimeoutId] = useState(0);


    const [profile, setProfile] = useState({
        label:
            !!userProfile &&
            userProfile?.ownerRegisterNo +
            " - " +
            userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
        value: localStorage.getItem("EAHSUserID"),
    });



    const uniqueCategories = ['draft', ...Array.from(new Set(horsesList.filter((x) => x.status != "" && x.status?.toLowerCase() != "draft").map(horse => horse.status)))];
    const statusToCount = ['pendingreview', 'waitinglist', 'completed', 'pendingpayment'];

    // getShowDetails
    async function getShowDetails(showId) {
        try {
            const res = await axiosInstance.get(`/showentry/getshowentrybyid?id=${showId}&Langauge=${currentLanguage}`);
            if (res.status == 200) {
                const formattedData = {
                    showName: res?.data?.result?.showName,
                    showNameEn: res?.data?.result?.showNameEn,
                    showNameAr: res?.data?.result?.showNameAr,
                    showId: res?.data?.result?.id,
                    showFees: res?.data?.result?.entryFees,
                    maxHorses: res?.data?.result?.maxHorseNumberPerOwner,
                    completedRequestsCount: res?.data?.result?.completedRequestsCount,
                    participationOpend: res?.data?.result?.isShowRegisterStarted,
                    isInternationalShow: res?.data?.result?.isInternational,
                    isEarlyYearling: res?.data?.result?.isEarlyYearling,
                    isLocalRegistrationOpen: res?.data?.result?.isLocalRegistrationOpen ?? false,
                    isInternationalRegistrationOpen: res?.data?.result?.isInternationalRegistrationOpen ?? false,
                    isFoalRegistrationOpen: res?.data?.result?.isFoalRegistrationOpen ?? false,
                    isDailyShow: res?.data?.result?.isDailyShow ?? false,
                    showDaysList: res?.data?.result?.showDaysList ?? []
                }
                setMaxAllowedHorses(formattedData.maxHorses);
                setShowDetails(formattedData);
                setDetailsLoaded(true);
            }

        } catch (error) {
            console.error('error in loading Show Details', error);
            setDetailsLoaded(true);
        }

    }

    // getHorsesList
    // ShowEntry/GetShowEntryOwnerHorses
    async function getHorseList(ownerId, isLoadMore = false, searchKeyword = "") {
        setLoaded(false);
        try {
            if (isLoadMore) {
                setIsloadingMore(true);
            } else {
                setLoaded(false);
                setSkip(0); // reset skip when refreshing
            }
            const res = await axiosInstance.post('/ShowEntry/GetShowEntryOwnerHorses', {
                showId: showId,
                ownerId: ownerId,
                createdBy: ownerId,
                langauge: localStorage.getItem('eahsLang'),
                skip: isLoadMore ? skipHorses : 0,
                take: take,
                ...(!!searchKeyword && {
                    searchValue: searchKeyword,
                }),
            })
            if (res.status == 200) {
                setTotalCount(res.data?.totalCount);
                const formatedData = res.data.horsesList.map((horse) => ({
                    isSelected: !!!horse?.showHorseStatus ? false : true,
                    name: horse?.name,
                    regNr: horse?.registerNumber,
                    ownerName: horse?.owner,
                    origin: horse?.origin,
                    id: horse?.id,
                    status: horse?.showHorseStatus,
                    birthDate: horse?.birthDate,
                    isRegisterd: horse?.isRegisterd,
                    isEarlyYearlingHorse: horse?.isEarlyYearlingHorse,
                    isQualified: horse?.isQualified,
                    showHorseId: horse?.showHorseId ?? '',
                    notEligibleReason: horse?.notEligibleReason ?? ''
                }));
                if (isLoadMore == false) {
                    setTotalIncomingHorses(formatedData.length);
                } else {
                    setTotalIncomingHorses(totalIncomingHorses + formatedData.length);
                    debugger;
                }

                const combinedMap = new Map();

                formatedData.forEach(horse => {
                    combinedMap.set(horse.id, horse);
                });
                if (isLoadMore == false) {
                    const res2 = await getShowEntryHorses(ownerId, showId);
                    const participatedHorses = res2.map((horse, index) => ({
                        isSelected: !!!horse?.statusName ? false : true,
                        name: horse?.horseName,
                        regNr: horse?.horseRegisterNo,
                        ownerName: horse?.ownerName ?? '',
                        origin: horse?.horseOrigin,
                        id: horse?.horseId,
                        status: horse?.statusName,
                        birthDate: horse?.horseBirthDate,
                        isRegisterd: horse?.isRegistered,
                        isEarlyYearlingHorse: horse?.isEarlyYearlingHorse,
                        isQualified: true,
                        amount: horse?.amount,
                        categoryName: horse?.categoryName ?? '',
                        showHorseId: horse?.id ?? '',
                        notEligibleReason: horse?.notEligibleReason ?? ''
                    }));


                    participatedHorses.forEach(horse => {
                        if (!combinedMap.has(horse.id)) {
                            combinedMap.set(horse.id, horse);
                        }
                    });
                }

                const combinedHorses = Array.from(combinedMap.values());
                if (isLoadMore) {
                    setHorsesList(prev => {
                        const existingIds = new Set(prev.map(h => h.id));
                        const newUniqueHorses = combinedHorses.filter(h => !existingIds.has(h.id));
                        return [...prev, ...newUniqueHorses];
                    });
                    setSkip(prev => prev + take);
                } else {
                    setHorsesList(combinedHorses);
                    setSkip(take);
                }

            }
        } catch (error) {
            console.error('Error in getting horses List', error)
            setLoaded(true);
        } finally {
            setLoaded(true);
            setIsloadingMore(false);
        }
    }


    function addRemoveHorse(id, isRemovingCall = false, selectedDay) {


        const maxReached = (horsesList.filter((x) => x.isSelected == true || statusToCount.includes(x.status)).length >= maxAllowedHorses) && (maxAllowedHorses > 0);
        if (maxReached && !isRemovingCall) {
            toast.error(translate('web.maxHorsesReached', 'you Have Reached The maximum Horses to add'));
            return;
        }
        if (showDetails?.isDailyShow) {
            setHorsesList((prev) => {
                return prev.map(horse =>
                    horse.id === id ? { ...horse, isSelected: !horse.isSelected, showDayId: selectedDay ?? "" } : horse
                );
            });
        } else {
            setHorsesList((prev) => {
                return prev.map(horse =>
                    horse.id === id ? { ...horse, isSelected: !horse.isSelected } : horse
                );
            });
        }

    }
    useEffect(() => {
        getShowDetails(showId);
        getHorseList(ownerId);

    }, [])

    // type to search
    const horsesServerSearch = (searchKeyword) => {
        if (timeoutId > 0) {
            clearTimeout(timeoutId);
        }
        const id = setTimeout(async () => {
            getHorseList(profile?.value, false, searchKeyword)


        }, 1000);

        setTimeoutId(id);
    };

    // controlers


    const showBtn = showDetails?.isInternationalShow || showDetails?.isEarlyYearling;
    const horseCardContainer = showDetails?.participationOpend ? 'col-xl-9 col-lg-8 col-md-6  col-sm-12 col-12' : 'col-12';
    const horseCard = showDetails?.participationOpend ? 'col-md-4 col-sm-6 col-12' : 'col-lg-3 col-md-4 col-sm-6 col-12';
    // const displayedHorses = horsesList.filter(item => horseSearchValue.toLowerCase() === '' || item?.name?.toLowerCase()?.includes(horseSearchValue.toLowerCase()) || item?.regNr?.toLowerCase()?.includes(horseSearchValue.toLowerCase()));
    const displayedHorses = horsesList;

    function saveAsDraft() {
        const selectedHorses = horsesList.filter(horse => horse.isSelected);
        createShowEntry('Draft', selectedHorses, showId).then((res) => {
            if (res) {
                toast.success(translate('web.savedAsDraft', 'Saved As Draft'));
                getHorseList(ownerId);
            } else {
                getHorseList(ownerId);
                toast.error(translate('web.unexpectedError', 'Unexpected Error'))
            }
        })
    }

    function submitHorses() {
        const selectedHorses = horsesList.filter(horse => horse.isSelected);
        createShowEntry('Checkout', selectedHorses, showId).then((res) => {
            if (res == true) {
                toast.success(translate('web.savedSuccessfully', 'Saved Successfully'));
                navigate(`/showEntryCheckoutPage?showId=${showId}&showNameAr=${showDetails.showNameAr}&showNameEn=${showDetails.showNameEn}`);
            } else {
                toast.error(res);
                getHorseList(ownerId);
            }
        })
    }

    if (!detailsLoaded) {
        return (
            <Loader />
        )
    }

    return (
        <>
            <ToastContainer
                position="top-right"
                closeOnClick
                theme="colored"
                autoClose={5000}
            />
            <div className='row'>
                <h2 className={termsTitle + " d-flex align-items-center flex-wrap"}>
                    {showDetails?.showName}
                    {showBtn &&
                        <div className='ms-auto d-flex align-items-center flex-wrap'>
                            {showDetails?.isFoalRegistrationOpen &&
                                <NewActionButton
                                    onClick={() => navigate(`/addEarlyYearlingHorse?showNameAr=${showDetails?.showNameAr}&showNameEn=${showDetails?.showNameEn}&showId=${showId}`)}
                                    classNames='btn-outline-secondary w-unset'
                                    text={translate('web.addFoalHorse', 'Add Foal')}
                                />
                            }
                            {showDetails?.isInternationalRegistrationOpen &&
                                <NewActionButton
                                    onClick={() => navigate(`/addInternationalHorse?showNameAr=${showDetails?.showNameAr}&showNameEn=${showDetails?.showNameEn}&showId=${showId}`)}
                                    classNames='btn-danger ms-2 w-unset'
                                    text={translate('web.addInterNationalHorse', 'Add International horse')}
                                />
                            }
                        </div>
                    }
                </h2>

                <div className={showIconsContainer}>
                    <div className={iconContainer}>
                        <img src={getDirhamImage(currentLanguage)} alt='AED' style={aedLogoStyle} />
                        <span>{`${translate("web.showFees", "Show Fees")} ${showDetails?.showFees?.toLocaleString('en-US')} ${translate('web.aed', 'AED')}`}</span>
                    </div>
                    <div className={iconContainer}>
                        <i className=" fa-solid fa-chess-knight C89C66" />
                        <span>{`${showDetails?.maxHorses == 0 ? '' : showDetails?.maxHorses} ${showDetails?.maxHorses == 0 ? translate('web.unlimited', 'unlimited') : translate("web.horsesmax", `horses max`)}`}</span>
                    </div>
                    <div className={iconContainer}>
                        <i className=" fa-solid fa-chess-knight C89C66" />
                        <span>{`${translate('web.selectedHorses', 'Selected Horses')} ( ${horsesList?.filter((x) => x.isSelected == true || statusToCount.includes(x.status)).length} ${maxAllowedHorses > 0 ? ('/' + maxAllowedHorses) : ''})`}</span>
                    </div>

                </div>
                {/* horse List */}
                {showDetails?.participationOpend &&
                    <div className='col-xl-3 col-lg-4 col-md-6  col-sm-12 col-12' style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                        <SearchBox placeholder={translate('web.search', 'search')} value={horseSearchValue} onChange={(e) => { setHorseSearchValue(e.target.value); horsesServerSearch(e.target.value); }} isPadding isFullWidth={true} />
                        <UserDropDown key={'userDropDown'} profile={profile} setProfile={setProfile} onChange={(value) => { setSkip(0); getHorseList(value, false); }} />
                        {!loaded && <Loader />}
                        {showDetails?.isLocalRegistrationOpen && <>
                            {displayedHorses?.filter(x => x?.isRegisterd).length > 0 &&
                                <h5 className='fw-bold mt-2'>
                                    {translate('web.registeredHorses', 'Registeded Horses')}
                                </h5>
                            }
                            {displayedHorses?.filter(x => x?.isRegisterd).map((horse, index) => (
                                <ShowEntryHorseCard toast={toast} showDetails={showDetails} key={`horse${index}`} showId={showId} horse={horse} onClick={(selectedDay) => { addRemoveHorse(horse.id, false, selectedDay); setActiveTab('draft') }} />
                            ))}
                        </>}
                        {showDetails.isInternationalRegistrationOpen && <>
                            {displayedHorses?.filter(x => !x?.isRegisterd && !x?.isEarlyYearlingHorse).length > 0 &&
                                <h5 className='fw-bold mt-2'>
                                    {translate('web.internationalHorses', 'International Horses')}
                                </h5>
                            }
                            {displayedHorses?.filter(x => !x?.isRegisterd && !x?.isEarlyYearlingHorse).map((horse, index) => (
                                <ShowEntryHorseCard toast={toast} showDetails={showDetails} key={`intHorse${index}`} showId={showId} horse={horse} onClick={(selectedDay) => { addRemoveHorse(horse.id, false, selectedDay); setActiveTab('draft') }} />
                            ))}
                        </>}
                        {showDetails?.isFoalRegistrationOpen && <>
                            {displayedHorses?.filter(x => !x?.isRegisterd && x?.isEarlyYearlingHorse).length > 0 &&
                                <h5 className='fw-bold mt-2'>
                                    {translate('web.foalHorse', 'Foal Horses')}
                                </h5>
                            }
                            {displayedHorses?.filter(x => !x?.isRegisterd && x?.isEarlyYearlingHorse).map((horse, index) => (
                                <ShowEntryHorseCard toast={toast} showDetails={showDetails} key={`foalHorse${index}`} showId={showId} horse={horse} onClick={(selectedDay) => { addRemoveHorse(horse.id, false, selectedDay); setActiveTab('draft') }} />
                            ))}
                        </>}
                        {totalIncomingHorses < totalcount &&
                            <>
                                {isLoadingMore == false ?
                                    <NewActionButton text={translate('web.loadMore', 'Load More')} isButton={false} onClick={() => {
                                        getHorseList(profile.value, true);
                                    }} /> :
                                    <Loader />
                                }
                            </>}
                    </div>
                }
                {/* Horse Tabs */}
                <div className={horseCardContainer}>
                    <div className="row  second_section_bar " style={{ cursor: 'pointer', justifyContent: 'flex-start' }}>
                        {uniqueCategories.map((item, index) => (
                            <>
                                <div
                                    className={"col-lg-2 col-md-4 col-sm-6 col-8 my-2 text-center px-0"} style={{ minWidth: 250 }}
                                    onClick={() => setActiveTab(item)}
                                >

                                    <span className={`${activeTab == item ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 14 }}>{translate(`web.${convertToCamelCase(item)}`, convertToCamelCase(item))}</span>

                                    <div className="service_bar_underline" style={activeTab == item ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
                                </div>
                            </>
                        ))}
                    </div>

                    {horsesList.filter((x) => x.isSelected == true && (x.status.toLowerCase() == activeTab || x.status == "")).length > 0 && activeTab == 'draft' &&
                        <div className='row ' >

                            {horsesList.filter((x) => x.isSelected == true && (x.status.toLowerCase() == activeTab || x.status == "")).map((horse, index) => (
                                <div className={horseCard}>
                                    <ShowEntryHorseCard toast={toast} key={`horse${index}`} showDetails={showDetails} showId={showId} horse={horse} onClick={(selectedDay) => addRemoveHorse(horse.id, true, selectedDay)} isSelectedTab={true} />
                                </div>

                            ))}
                        </div>
                    }
                    {horsesList.filter((x) => x.isSelected == true && (x.status.toLowerCase() == activeTab || x.status == "")).length == 0 && activeTab == 'draft' &&
                        <div className='row mx-0 mb-main'>
                            <div className={noDataCard}>
                                <span className='red fw-bold'>
                                    {translate('web.noDraft', 'No Draft')}
                                </span>
                            </div>
                        </div>
                    }
                    {horsesList.filter((x) => x.status == activeTab && x.status != 'draft').length > 0 &&
                        <div className='row ' >
                            {horsesList.filter((x) => x.status == activeTab && x.status != 'draft').map((horse, index) => (
                                <div className={horseCard}>
                                    <ShowEntryHorseCard toast={toast} key={`horse${index}`} showDetails={showDetails} showId={showId} horse={horse} onClick={(selectedDay) => addRemoveHorse(horse.id, false, selectedDay)} isSelectedTab={true} />
                                </div>
                            ))}
                        </div>
                    }
                    {horsesList.filter((x) => x.isSelected == true || statusToCount.includes(x.status)).length >= 0 &&
                        <div className={eFormButtonsContainer}>
                            {showDetails?.isDailyShow == true ? <></> :
                                <DraftBtn key={'draft'} onClick={() => saveAsDraft()} />
                            }
                            <SubmitServiceBtn onClick={() => (submitHorses())} />
                        </div>
                    }
                </div>
            </div >
        </>
    )
}
